<template>
  <v-list-group class="switch_layer_option" :value="true">
    <template v-slot:activator>
      <v-container fluid
        ><v-icon>warning</v-icon>&nbsp;&nbsp;{{ $t("common.option") }}
      </v-container>
    </template>

    <v-list-item v-if="enable_latlng">
      <v-list-item-content>
        <v-list-item-title>{{ $t("common.longitude") }}</v-list-item-title>
        <v-list-item-action-text>
          <v-chip
            v-if="enable_latitude_none"
            class="ma-2"
            label
            key="longitude_field_none"
            :color="current_longitude_field == null ? 'red' : 'grey'"
            text-color="white"
            @click="change_current_longitude_field(null)"
            >{{ $t("common.none") }}</v-chip
          >
          <template v-for="field in current_fields">
            <v-chip
              class="ma-2"
              label
              :key="'longitude_' + field"
              :color="current_longitude_field == field ? 'green' : 'grey'"
              text-color="white"
              @click="change_current_longitude_field(field)"
              >{{ field }}</v-chip
            >
          </template>
        </v-list-item-action-text>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="enable_latlng">
      <v-list-item-content>
        <v-list-item-title>{{ $t("common.latitude") }}</v-list-item-title>

        <v-list-item-action-text>
          <v-chip
            v-if="enable_longitude_none"
            class="ma-2"
            label
            key="latitude_field_none"
            :color="current_latitude_field == null ? 'red' : 'grey'"
            text-color="white"
            @click="change_current_latitude_field(null)"
            >{{ $t("common.none") }}</v-chip
          >
          <template v-for="field in current_fields">
            <v-chip
              class="ma-2"
              label
              :key="'latitude_' + field"
              :color="current_latitude_field == field ? 'green' : 'grey'"
              text-color="white"
              @click="change_current_latitude_field(field)"
              >{{ field }}</v-chip
            >
          </template>
        </v-list-item-action-text>
      </v-list-item-content>
    </v-list-item>
    <v-container fluid text-center>
      <v-list-item v-if="enable_crs">
        <v-list-item-content
          ><v-list-item-title>{{
            $t("common.importDialog.coordinateReferenceSystem")
          }}</v-list-item-title>
          <v-list-item-action-text>
            <template v-for="crs_option in crs_options_array">
              <v-chip
                class="ma-2"
                label
                :key="crs_option"
                :color="current_crs_option == crs_option ? 'green' : 'grey'"
                text-color="white"
                @click="change_current_crs_option(crs_option)"
                >{{ crs_option }}</v-chip
              >
            </template>
          </v-list-item-action-text>
        </v-list-item-content>
      </v-list-item>
    </v-container>
  </v-list-group>
</template>

<script>
import { IMPORT } from "./Global.js";

export default {
  data() {
    return {
      crs_options_array: IMPORT.CRS_OPTIONS_ARRAY,
    };
  },

  props: {
    enable_latlng: {
      type: Boolean,
      default: false,
    },
    enable_crs: {
      type: Boolean,
      default: false,
    },
    enable_latitude_none: {
      type: Boolean,
      default: false,
    },
    enable_longitude_none: {
      type: Boolean,
      default: false,
    },
    current_crs_option: { type: String, default: IMPORT.CRS_OPTIONS.WGS1984 },
    current_latitude_field: [String, Number],
    current_longitude_field: [String, Number],
    current_fields: [Array],
    change_current_latitude_field: [Function],
    change_current_longitude_field: [Function],
    change_current_crs_option: [Function],
  },
};
</script>

<style>
</style>